import * as types from '../actions/types';

const initialState = {
    uniqueIdGenerationPageData:[],
    success: false
}

export default function uniqueIdGenerationPageReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.PAGE_UNIQUE_ID_GENERATION_QUERY:
            return {
                uniqueIdGenerationPageData:action.payload,
                success: true
            } 
        default:
            return state
    }
}